import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'found';

import { routes } from '../../routes';
import { MainMenu } from '../../components/menus/MainMenu/MainMenu';
import { MenuItem } from '../../components/menus/MainMenu/MenuItem';
import Spacer from '../../components/Spacer';
import { faPlug, faStream } from '@fortawesome/free-solid-svg-icons';
import ContentCenterer from '../../components/ContentCenterer';

const PageSplitter = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  padding: 0px 0px;
  flex: 1;
  display: flex;
  margin-top: 77px;
`;

type Props = {
  children?: React.ReactNode;
};

function MenuWrapper({ children }: Props) {
  const { router, match } = useRouter();

  const isSelected = (routeMatch: string[]): boolean => {
    const { routes } = match;
    const currentRouter = routes[routes.length - 1];
    if (!currentRouter.path) {
      return false;
    }

    for (let i = 0; i < routeMatch.length; i++) {
      if (currentRouter.path.includes(routeMatch[i])) {
        return true;
      }
    }

    return false;
  };

  return (
    <>
      <MainMenu>
        <MenuItem
          fontawesomeIcon={{ icon: faPlug, color: '#5c6ef8' }}
          selected={isSelected([routes.subscriptions, '/subscriptions/'])}
          onClick={() => router.push(routes.subscriptions)}
        >
          Subscriptions
        </MenuItem>
        <Spacer horizontal spacing={2} />
        <MenuItem
          fontawesomeIcon={{ icon: faStream, color: '#5c6ef8' }}
          selected={isSelected([routes.activity])}
          onClick={() => router.push(routes.activity)}
        >
          Activity
        </MenuItem>
      </MainMenu>
      <ContentCenterer>
        <PageSplitter>
          <Content>{children}</Content>
        </PageSplitter>
      </ContentCenterer>
    </>
  );
}

export default MenuWrapper;
